<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Distribution Rules</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row align-items-center">
                            <div class="col-9">
                                <h3 class="mb-0" id="leads_main_heading">Distribution Rules</h3>
                            </div>
                            <div class="col-3 text-right">
                                <el-switch v-model="distribute_leads_evenly"
                                    @change="changeDistributionStyle"></el-switch> <span class="text-sm">Distribute
                                    Leads Evenly</span>
                            </div>
                        </div>
                    </template>
                    <div>
                        <el-table :data="venue_specialists" row-key="id" v-loading="loading"
                            header-row-class-name="thead-light" id="lead_venue_specialists_table">
                            <el-table-column label="Name" prop="name" min-width="100px" sortable="custom">
                                <template v-slot="{ row }">
                                    <span class="font-weight-600 name mb-0 text-sm">{{
                                        row.name
                                        }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="Wedding" min-width="70px">
                                <template v-slot="{ row }">
                                    <base-checkbox v-model="row.event_type_wedding"
                                        @input="updateField(row.id, 'event_type_wedding', row.event_type_wedding)"
                                        class="ml-3">
                                    </base-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="Corporate" min-width="70px">
                                <template v-slot="{ row }">
                                    <base-checkbox v-model="row.event_type_corporate"
                                        @input="updateField(row.id, 'event_type_corporate', row.event_type_corporate)"
                                        class="ml-3">
                                    </base-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="Social" min-width="70px">
                                <template v-slot="{ row }">
                                    <base-checkbox v-model="row.event_type_social"
                                        @input="updateField(row.id, 'event_type_social', row.event_type_social)"
                                        class="ml-3">
                                    </base-checkbox>
                                </template>
                            </el-table-column>

                            <el-table-column label="Industries" min-width="200px">
                                <template v-slot="{ row }">
                                    <el-select
                                        v-if="row.event_type_corporate"
                                        v-model="row.distribution_rule.industry"
                                        multiple
                                        collapse-tags
                                        placeholder="Select industries..."
                                        @change="updateField(row.id, 'industry', row.distribution_rule.industry)"
                                        size="mini"
                                        class="w-100"
                                    >
                                        <el-option
                                            v-for="industry in industries"
                                            :key="industry"
                                            :label="industry"
                                            :value="industry"
                                        >
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>

                            <el-table-column label="Lead Cap (/MO)" min-width="160px">
                                <template v-slot="{ row }">
                                    <span @click.prevent="updateField(row.id, 'max_cap_active', !row.max_cap_active)"
                                        id="active_toggle" class="float-left">
                                        <base-switch v-model="row.max_cap_active"></base-switch>
                                    </span>
                                    <el-input-number placeholder=" " v-model="row.max_cap"
                                        @change="updateField(row.id, 'max_cap', row.max_cap)"
                                        class="inline-input float-left ml-2" size="mini" resize="horizontal"
                                        v-if="row.max_cap_active" :min="1"></el-input-number>
                                </template>
                            </el-table-column>

                            <el-table-column label="Paused" min-width="150px" class-name="paused-attributes">
                                <template v-slot="{ row }">
                                    <div  v-if="row.active">
                                        <span @click.prevent="updatePausedAttribute(row)" class="float-left">
                                            <base-switch v-bind:value="isPaused(row)"></base-switch>
                                        </span>
                                        <el-button v-if="isPaused(row)"
                                            @click.stop="showPauseUntilDatePicker = true; selectedVenueRep = row"
                                            class="text-center ml-2" :class="{'text-danger': ! pausedUpto(row) }"
                                        >
                                            {{ pausedUpto(row) || 'Select a date' }}
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column label="Active" min-width="120px">
                                <template v-slot="{ row }">
                                    <span @click.prevent="updateField(row.id, 'active', !row.active)"
                                        id="toggle_scheduler_access">
                                        <base-switch v-model="row.active"></base-switch>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </card>
            </div>
        </div>
        <el-dialog v-if="showPauseUntilDatePicker"
            width="440px"
            :visible.sync="showPauseUntilDatePicker"
            :append-to-body="true" center
            :before-close="handlePauseModalClose"
        >
            <template #title>
                <div class="font-weight-bold">
                    Select A Date
                </div>
            </template>
            <div class="row">
                <select-round-robin-pause-until-date :venue-rep="selectedVenueRep"
                    :show-error="showDateSelectionError"
                    @update-pause-till-date="updatePausedTillAttribute($event)" />
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import { Table, TableColumn, Select, Option, Loading, InputNumber, Input, Switch, Button } from "element-ui";
    import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
    import tableMixin from "@/helpers/remoteTableMixin";
    import { LeadService } from "@/services";
    import CompanyService from "@/services/company.service";
    import { mapState } from "vuex";
    import { dialog } from "element-ui";
    import SelectRoundRobinPauseUntilDate from "@/views/Widgets/Inspections/SelectRoundRobinPauseUntilDate.vue";

    export default {
        mixins: [tableMixin],
        components: {
            RouteBreadCrumb,
            SelectRoundRobinPauseUntilDate,
            [dialog.name]: dialog,
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [InputNumber.name]: InputNumber,
            [Switch.name]: Switch,
            [Button.name]: Button
        },
        data() {
            return {
                venue_specialists: [],
                distribute_leads_evenly: true,
                loading: true,
                showPauseUntilDatePicker: false,
                wasAPauseTillDateSelected: false,
                showDateSelectionError: false,
                selectedVenueRep: {},
                industries: []
            };
        },
        created() {
            this.loadPage();
            this.loadIndustries();
        },
        computed: {
            ...mapState("country/", {
                country: (state) => state.country || "AU",
            }),
            isPaused: () => (row) => {
                return row.distribution_rule?.is_paused;
            },
            pausedUpto: () => row => row.distribution_rule?.paused_upto
        },
        methods: {
            handlePauseModalClose(done) {
                if (this.pausedUpto(this.selectedVenueRep) || this.wasAPauseTillDateSelected) {
                    this.showDateSelectionError = false;
                    this.selectedVenueRep = {};
                    done();
                } else {
                    this.showDateSelectionError = true;
                }
            },
            async updatePausedAttribute(row) {
                this.selectedVenueRep = row;
                this.showPauseUntilDatePicker = row.distribution_rule?.is_paused ? false : true;
                await this.updateField(row.id, 'pause', !row.distribution_rule?.is_paused);
            },
            async updatePausedTillAttribute(payload) {
                if (payload.date) {
                    this.wasAPauseTillDateSelected = true;
                }

                await this.updateField(payload.id, 'paused_till', payload.date);
                this.showPauseUntilDatePicker = false;
                this.selectedVenueRep = {};
                this.wasAPauseTillDateSelected = false;
                this.showDateSelectionError = false;
            },
            async loadPage() {
                this.loading = true;
                let data = await LeadService.getVenueSpecialists();
                let temp = [];
                data.data.forEach(vc => {
                    if (vc.country === this.country) {
                        // Initialize distribution_rule object if not present
                        if (!vc.distribution_rule) {
                            vc.distribution_rule = {};
                        }
                        // Initialize industry array if not present
                        if (!vc.distribution_rule.industry) {
                            vc.distribution_rule.industry = [];
                        }
                        temp.push(vc);
                    }
                });
                temp.sort(function (a, b) {
                    a = a.name;
                    b = b.name;
                    return (a === b) ? 0 : (a > b) ? 1 : -1;
                });
                this.venue_specialists = temp;

                this.loadSettings();
                this.loading = false;
            },
            async loadIndustries() {
                try {
                    const response = await CompanyService.getIndustries();
                    this.industries = response.data || [];
                } catch (error) {
                    console.error('Failed to load industries:', error);
                    this.industries = [];
                }
            },
            async loadSettings() {
                let settings = await LeadService.getVenueSpecialistSetting();
                this.distribute_leads_evenly = (this.country).toLowerCase() == "uk" ? settings.data.distribute_leads_evenly_uk : settings.data.distribute_leads_evenly_au;
            },
            async updateField(id, field, value) {
                this.loading = true;
                let data = await LeadService.changeVenueSpecialistAttribute(id, field, value);
                this.loadPage();
                this.loading = false;
            },
            async changeDistributionStyle() {
                this.loading = true;;
                let attribute = 'distribute_leads_evenly_' + (this.country).toLowerCase();
                let data = await LeadService.changeVenueSpecialistSetting(attribute, this.distribute_leads_evenly);
                this.loadSettings();
                this.loading = false;
            },
        },
        watch: {
            showPauseUntilDatePicker: function(newVal) {
                if (newVal) {
                    if (this.pausedUpto(this.selectedVenueRep)) {
                        this.wasAPauseTillDateSelected = true;
                        return;
                    }
                }

                this.wasAPauseTillDateSelected = false;
            }
        }
    };
</script>
<style lang="scss">
    .no-border-card .card-footer {
        border-top: 0;
    }

    .el-table .cell {
        word-break: normal;
    }

    .el-table--enable-row-hover .el-table__body tr:hover>td {
        background-color: #f6f9fc !important;
        cursor: pointer;
    }

    .inline-input {
        width: 120px;
        display: inline-block;
    }

    #active_toggle {
        display: inline-block;
    }

    .paused-attributes {
        .cell > div {
            display: flex;
            align-items: center;
        }
    }
</style>